/*!

=========================================================
* Argon Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Login from "views/Login.js";
import ResetPassword from "views/ResetPassword.js";
import ForgotPassword from "views/ForgotPassword.js";
import Products from "views/products/List.js";
import ProductEmoney from "views/product-emoney/List.js";
import BarcodeGenerator from "views/products/BarcodeGenerator";
import Users from "views/users/List.js";
import Settings from "views/settings/Index.js";
import EmployeeUpload from "views/employees/Upload.js";
import PointOfSales from "views/point-of-sales/Index.js";
import CheckoutHistory from "views/point-of-sales/CheckoutHistory.js";
import CreditHistory from "views/point-of-sales/CreditHistory.js";
import CreditCategory from "views/CreditCategory/List.js";
import CreditReport from "views/creditReport/Index";
import CreditApprovals from "views/creditApprovals/List";
import UserCreditApprovals from "views/userCreditApprovals/List";
import Warehouses from "views/warehouses/List";
import StockReports from "views/stockReport/Index";
import Loyalty from "views/loyalty/List";
import Shopping from "views/shopping/List";

var routes = [
  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: Login,
    layout: "/auth",
    roles: ["admin"],
  },
  {
    path: "/index",
    name: "Point of sales",
    icon: "ni ni-cart text-primary",
    component: PointOfSales,
    layout: "/admin",
    roles: ["admin", "cashier"],
    section: "POS",
  },
  {
    path: "/checkout-history",
    name: "Riwayat checkout",
    icon: "ni ni-bullet-list-67 text-red",
    component: CheckoutHistory,
    layout: "/admin",
    roles: ["admin", "cashier"],
    section: "POS",
  },
  {
    path: "/shopping",
    name: "Shopping",
    icon: "ni ni-cart text-orange",
    component: Shopping,
    layout: "/admin",
    roles: ["admin", "cashier"],
    section: "POS",
  },
  {
    path: "/credit-history",
    name: "Riwayat kredit",
    icon: "ni ni-bullet-list-67 text-blue",
    component: CreditHistory,
    layout: "/admin",
    roles: ["admin", "cashier"],
    section: "Kredit",
  },
  {
    path: "/checkout-receipt",
    name: "Checkout receipt",
    icon: "ni ni-bullet-list-67 text-blue",
    component: CreditHistory,
    layout: "/print",
    roles: ["admin"],
    section: "Kredit",
  },
  {
    path: "/credit-category",
    name: "Kategori kredit",
    icon: "ni ni-bullet-list-67 text-success",
    component: CreditCategory,
    layout: "/admin",
    roles: ["admin"],
    section: "Kredit",
  },
  {
    path: "/credit-approvals",
    name: "Approval kredit",
    icon: "ni ni-archive-2 text-blue",
    component: CreditApprovals,
    layout: "/admin",
    roles: ["pengawas"],
    section: "Kredit",
  },
  {
    path: "/user-credit-approvals",
    name: "User kredit approval",
    icon: "ni ni-archive-2 text-blue",
    component: UserCreditApprovals,
    layout: "/admin",
    roles: ["admin", "cashier"],
    section: "Kredit",
  },
  {
    path: "/credit-reports",
    name: "Report kredit",
    icon: "ni ni-archive-2 text-success",
    component: CreditReport,
    layout: "/admin",
    roles: ["admin"],
    section: "Kredit",
  },
  {
    path: "/warehouses",
    name: "Warehouse",
    icon: "ni ni-building text-red",
    component: Warehouses,
    layout: "/admin",
    roles: ["admin"],
    section: "Produk"
  },
  {
    path: "/products",
    name: "Produk",
    icon: "ni ni-box-2 text-blue",
    component: Products,
    layout: "/admin",
    roles: ["admin", "cashier"],
    section: "Produk"
  },
  {
    path: "/products-emoney",
    name: "E-Money",
    icon: "fa-solid fa-wallet text-orange",
    component: ProductEmoney,
    layout: "/admin",
    roles: ["admin", "cashier"],
    section: "Produk"
  },
  {
    path: "/stock-report",
    name: "Riwayat Stok",
    icon: "ni ni-world-2 text-green",
    component: StockReports,
    layout: "/admin",
    roles: ["admin", "cashier"],
    section: "Produk"
  },
  {
    path: "/generate-barcode",
    name: "Generate barcode",
    icon: "ni ni-button-pause text-orange",
    component: BarcodeGenerator,
    layout: "/admin",
    roles: ["admin"],
    section: "Produk"
  },
  {
    path: "/loyalty",
    name: "Loyalty",
    icon: "fa-solid fa-trophy text-yellow",
    component: Loyalty,
    layout: "/admin",
    roles: ["admin", "cashier"],
    section: "Loyalty",
  },
  {
    path: "/users",
    name: "User",
    icon: "ni ni-single-02 text-yellow",
    component: Users,
    layout: "/admin",
    roles: ["admin"],
  },
  {
    path: "/employees",
    name: "Karyawan",
    icon: "ni ni-circle-08 text-green",
    component: EmployeeUpload,
    layout: "/admin",
    roles: ["admin"],
  },
  {
    path: "/settings",
    name: "Settings",
    icon: "ni ni-settings-gear-65 text-warning",
    component: Settings,
    layout: "/admin",
    roles: ["admin"],
  },
  {
    path: "/reset-password",
    name: "Reset Password",
    icon: "ni ni-lock-circle-open text-info",
    component: ResetPassword,
    layout: "/auth",
    roles: ["admin"],
  },
  {
    path: "/forgot-password",
    name: "Forgot Password",
    icon: "ni ni-key-25 text-info",
    component: ForgotPassword,
    layout: "/auth",
    roles: ["admin"],
  },
];
export default routes;
